<app-filter-dropdown
  name="category"
  [value]="categoryValue()"
  [placeholder]="'testSteps.filter.allCategories' | translate"
  [options]="categoryOptions()"
  (valueChange)="onChange('category', $event)"
/>

<app-filter-dropdown
  name="status"
  [value]="statusValue()"
  [placeholder]="'testSteps.filter.allStatuses' | translate"
  [options]="statusOptions()"
  (valueChange)="onChange('status', $event)"
/>

<app-filter-dropdown
  name="author"
  [value]="authorValue()"
  [placeholder]="'testSteps.filter.allAuthors' | translate"
  [options]="authorOptions()"
  (valueChange)="onChange('author', $event)"
/>

@if (hasFilters()) {
  <app-reset-filter-button [label]="'testSteps.filter.reset' | translate" (resetClick)="onReset()" />
}

<app-saved-views-menu
  [views]="savedViews()"
  [activeName]="activeSavedView()"
  [context]="'TEST_STEPS'"
  [projectId]="projectId()"
  (viewSelected)="onSavedViewSelected($event)"
  (viewSaved)="onSavedViewSaved($event)"
  (viewDeleted)="onSavedViewDeleted($event)"
  (viewDeleteFailed)="onSavedViewDeleteFailed($event)"
/>
